<script lang="ts">
  import { onDestroy, tick } from 'svelte';
  import { useQueryClient } from '@tanstack/svelte-query';
  import { assignmentReadsApi } from '$lib/api/assignmentReads';
  import { session } from '$lib/state/session.svelte';

  let { kind, recordId, dataId, ready, assignmentVersion }: {
    kind: 'issues' | 'leads'; recordId: number; dataId?: number; ready: boolean; assignmentVersion?: number;
  } = $props();
  const client = useQueryClient();
  let active = true;
  const pending = new Set<string>();
  const acknowledged = new Set<string>();
  onDestroy(() => { active = false; });
  type Observation = { kind: 'issues' | 'leads'; recordId: number; dataId?: number; ready: boolean; assignmentVersion?: number; userId?: number };
  function valid(observed: Observation) {
    return observed.ready && observed.recordId > 0 && observed.dataId === observed.recordId && observed.userId !== undefined &&
      (observed.kind === 'leads' || (Number.isSafeInteger(observed.assignmentVersion) && observed.assignmentVersion! >= 0));
  }
  async function afterDisplay(observed: Observation) {
    if (!valid(observed)) return;
    await tick();
    // Dismissal, a pending/failed refetch, a changed record, or logout before
    // the DOM flush must not mark a response that was never actually displayed.
    if (!active || !ready || kind !== observed.kind || recordId !== observed.recordId || dataId !== observed.dataId || assignmentVersion !== observed.assignmentVersion || session.me?.user.id !== observed.userId) return;
    const key = `${observed.userId}:${observed.kind}:${observed.recordId}:${observed.assignmentVersion ?? ''}`;
    if (pending.has(key) || acknowledged.has(key)) return;
    pending.add(key);
    try {
      await assignmentReadsApi.mark(observed.kind, observed.recordId, observed.assignmentVersion);
      acknowledged.add(key);
      void client.invalidateQueries({ queryKey: ['assignment-counts', observed.userId] });
    } catch { /* Do not clear a badge on failure. A later detail fetch can retry. */ }
    finally { pending.delete(key); }
  }
  $effect(() => {
    void afterDisplay({ kind, recordId, dataId, ready, assignmentVersion, userId: session.me?.user.id });
  });
</script>
